<template>
  <div class="full-height full-width">
    <div
      v-if="!loading"
      class="full-height full-width d-flex flex-column"
      :class="[classBtn]"
      style="position: relative"
    >
      <div class="flex-grow-0">
        <v-btn
          :color="c_type == 'number' ? 'primary' : ''"
          icon
          size="30"
          text
          @click="changeType('number')"
        >
          <v-icon>mdi-numeric-0-box-outline</v-icon>
        </v-btn>
        <v-btn
          :color="c_type == 'percent' ? 'primary' : ''"
          icon
          size="30"
          text
          @click="changeType('percent')"
        >
          <v-icon>mdi-percent</v-icon>
        </v-btn>
      </div>
      <ChartJSComponent
        :key="keyRender"
        class="flex-grow-1 full-height full-width"
        :class="classChart"
        :datasets="datasets"
        :labels="labels"
        :options="options"
        :plugins="plugins"
        :type="chartType"
      />
    </div>

    <div v-else class="flex-center full-height full-width"> <Loading /> </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import ChartJSComponent from '@components/chart/ChartJSComponent.vue'
import numberFormat from '@src/filters/number'
import { debounce } from '@utils'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import ChartDataDoughnutlabel from 'chartjs-plugin-doughnutlabel'
Chart.plugins.unregister(ChartDataLabels)
export default {
  components: { ChartJSComponent },
  props: {
    classBtn: String,
    classChart: {},
    data: { type: Array, required: true, default: () => [] },
    total: { type: [String, Number], required: true, default: 0 },
    labels: { type: Array, required: true, default: () => [] },
    backgroundColor: { type: Array, required: true, default: () => [] },
    loading: Boolean,
    titleText: {
      type: [String, Object],
    },
    isMultiDataSet: Boolean,
    legend: {
      type: Object,
      default: () => ({ display: false }),
    },

    option: {},
    type: {
      type: String,
      validator: function(value) {
        // The value must match one of these strings
        return ['number', 'percent'].indexOf(value) !== -1
      },
    },
  },
  data: (vm) => ({
    p_type: 'number',
    chartType: 'doughnut',
    keyRender: 0,
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
    options: {
      tooltips: {
        filter: function(tooltipItem, data) {
          if (vm.isMultiDataSet) {
            const maxCount =
              data.datasets[tooltipItem.datasetIndex].data.length - 1
            return (
              tooltipItem.index <
              data.datasets[tooltipItem.datasetIndex].data.length - 1
            )
          }

          return true
        },
        mode: 'nearest',
        callbacks: {
          label: function(tooltipItem, data) {
            let index = tooltipItem.index
            if (vm.isMultiDataSet) {
              index = tooltipItem.datasetIndex
            }
            let corporation = data.labels[index]
            return corporation
          },
          footer: function(tooltipItems, data) {
            if (tooltipItems.length == 0) return
            const tooltipItem = tooltipItems[0]
            let valor =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
            if (vm.c_type != 'percent') {
              return vm.$i18n.n(valor)
            } else {
              return `${getPercent(valor, vm.total)}%`
            }
          },
        },
      },
      title: { display: true, text: '', fontSize: 18 },
      plugins: {
        datalabels: {
          display: true,
          color: '#fff',
          formatter: function(value) {
            return numberFormat(value)
          },
          font: {
            size: '18',
          },
        },
        doughnutlabel: {
          labels: [
            {
              text: '0',
              font: {
                size: 20,
                weight: 'bold',
              },
            },
            {
              text: 'Tổng số',
            },
          ],
        },
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      legend: {
        display: true,
        position: 'left',
      },
      scales: {},
    },
    plugins: [ChartDataLabels, ChartDataDoughnutlabel],
  }),
  watch: {
    backgroundColor: {
      handler: 'initOption',
      immediate: true,
    },
    legend: {
      handler: 'initOption',
      immediate: true,
    },
    data: {
      handler: 'initOption',
      immediate: true,
    },
    labels: {
      handler: 'initOption',
      immediate: true,
    },
    option: {
      handler: 'initOption',
      immediate: true,
    },

    total: {
      handler: 'initOption',
      immediate: true,
    },
    type: {
      handler(value) {
        if (value != this.p_value) {
          this.changeType(value)
        }
      },
      immediate: true,
    },
  },
  computed: {
    c_type: {
      get() {
        return this.p_type
      },
      set(value) {
        this.$emit('update:type', value)
      },
    },
  },
  methods: {
    rerender() {
      this.keyRender++
    },
    initOptionForMultiDataSet() {
      this.datasets = []
      this.options.plugins.datalabels.display = false
      for (let index = 0; index < this.data.length; index++) {
        const data = this.data[index].slice()
        const total = data.reduce((acc, cur) => acc + cur, 0)
        data.push(this.total - total)
        const backgroundColor = this.backgroundColor[index].slice()
        this.datasets.push({ data, backgroundColor })
      }
    },
    initOptionForSingleDataSet() {
      this.datasets = [
        {
          data: this.data,
          backgroundColor: this.backgroundColor,
        },
      ]
    },
    initOption() {
      const vm = this
      vm.options.title.display = !!vm.titleText
      vm.options.legend = vm.legend
      if (vm.titleText) {
        const tilte =
          typeof vm.titleText == 'string'
            ? vm.titleText
            : vm.titleText[vm.c_type]
        vm.options.title.text = tilte
      }
      vm.options.plugins.doughnutlabel.labels[0].text = numberFormat(
        vm.total,
        3,
        1
      )
      if (vm.isMultiDataSet) {
        vm.initOptionForMultiDataSet()
      } else {
        vm.initOptionForSingleDataSet()
        const formatter =
          vm.p_type == 'percent'
            ? (value, context) => {
                return `${getPercent(value, vm.total)}%`
              }
            : function(value) {
                return numberFormat(value)
              }
        vm.options.plugins.datalabels.formatter = formatter
        vm.options = Object.assign({}, vm.options, vm.option)
      }
      vm.rerender()
    },
    changeType(type) {
      this.p_type = type
      this.c_type = type
      this.initOption()
    },
  },
}
function getPercent(value, total) {
  let num = (value || 0) / (total || 1)
  const percent = Math.round(num * 100).toFixed(0)
  return percent
}
</script>

<style scoped></style>
